import { useEffect, useState } from "react";
import { brokerPnl, brokerPositions, brokerLiveStatus, brokerAccount, autopilotActivity, floorStatus, tvControlGet } from "../../lib/api";

export function useCommandData(userId, tv) {
  const [d, setD] = useState({});
  useEffect(() => {
    let dead = false;
    const fast = async () => {
      const r = await Promise.allSettled([brokerPnl(userId), brokerPositions(userId), brokerLiveStatus(userId),
        autopilotActivity(userId), floorStatus(), tv ? tvControlGet(userId) : Promise.resolve(null)]);
      if (dead) return;
      const v = r.map((x) => (x.status === "fulfilled" ? x.value : undefined));
      setD((p) => ({ ...p, pnl: v[0] ?? p.pnl, positions: v[1]?.items ?? p.positions, live: v[2] ?? p.live,
        activity: v[3] ?? p.activity, floor: v[4] ?? p.floor, control: v[5] ?? p.control }));
    };
    const slow = async () => { try { const a = await brokerAccount(userId); if (!dead) setD((p) => ({ ...p, account: a })); } catch (e) { /* keep last */ } };
    fast(); slow();
    const t1 = setInterval(fast, 15000), t2 = setInterval(slow, 60000);
    return () => { dead = true; clearInterval(t1); clearInterval(t2); };
  }, [userId, tv]);
  return d;
}

export const equityOf = (a, open) => {
  if (!a) return null;
  const base = Number(a.alpaca?.equity || 0) + Number(a.coinbase?.usd_available || 0) + Number(a.kalshi?.balance || 0);
  const off = (open || []).filter((p) => !/alpaca/i.test(p.venue || ""))
    .reduce((s, p) => s + Number(p.notional || 0) * (1 + Number(p.pnl_pct || 0) / 100), 0);
  return base + off;
};
